import { ComponentType } from 'react';

export const withData =
  <P extends { data: any }>(defaultData: Partial<P['data']>) =>
  (Component: ComponentType<P>) => {
    return (props: P) => (
      <Component {...props} data={{ ...props.data, ...defaultData }} />
    );
  };
